import ThemedSvgIcon from './ThemedSvgIcon';

const UserShieldIcon = (props) => (
    <ThemedSvgIcon {...props}>
        {(fill) => (
            <svg width="25" height="21" viewBox="0 0 25 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.75 10.5C10.0761 10.5 11.3479 9.97322 12.2855 9.03553C13.2232 8.09785 13.75 6.82608 13.75 5.5C13.75 4.17392 13.2232 2.90215 12.2855 1.96447C11.3479 1.02678 10.0761 0.5 8.75 0.5C7.42392 0.5 6.15215 1.02678 5.21447 1.96447C4.27678 2.90215 3.75 4.17392 3.75 5.5C3.75 6.82608 4.27678 8.09785 5.21447 9.03553C6.15215 9.97322 7.42392 10.5 8.75 10.5ZM6.96484 12.375C3.11719 12.375 0 15.4922 0 19.3398C0 19.9805 0.519531 20.5 1.16016 20.5H16.3398C16.4102 20.5 16.4766 20.4922 16.5469 20.4805C13.5664 18.3281 12.6484 14.9727 12.5195 12.6602C11.8906 12.4727 11.2266 12.375 10.5391 12.375H6.96875H6.96484ZM19.0273 9.31641L14.3398 11.1914C13.9844 11.3359 13.75 11.6797 13.75 12.0625C13.75 14.5352 14.7617 18.6562 19.0156 20.4297C19.2461 20.5273 19.5078 20.5273 19.7383 20.4297C23.9883 18.6562 25 14.5352 25 12.0625C25 11.6797 24.7656 11.3359 24.4102 11.1914L19.7227 9.31641C19.5 9.22656 19.25 9.22656 19.0273 9.31641ZM23.1016 12.6875C22.9492 14.668 22.0391 17.2461 19.375 18.5352V11.1992L23.1016 12.6875Z"
                    fill={fill}
                />
            </svg>
        )}
    </ThemedSvgIcon>
);

export default UserShieldIcon;
